export enum PhonePlanIdsEnum {
  REWRITES_PHONE_PLAN = 2,
}
